import React from "react";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import ListItemTab from "./ListItemTab";

const SchedulingItem = ({ onClick, active }) => {
  return (
    <ListItemTab
      icon={CalendarDaysIcon}
      label="Scheduling"
      onClick={onClick}
      active={active}
    />
  );
};

export default SchedulingItem;
